import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { commissionQueries } from '@/services/commissions/commissions.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useCommissionManage = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('createCommission', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: commissionQueries.all() });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useCommissionManage;
